import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8322/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach Bearer token from Redux when present (set via setAuthToken below).
let _bearerToken = null;
export function setAuthToken(token) {
  _bearerToken = token || null;
}
api.interceptors.request.use((config) => {
  if (_bearerToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${_bearerToken}`;
  }
  return config;
});

// ── Products ─────────────────────────────────────────────────────────────────
export const getProducts    = (params) => api.get('/products', { params });
export const getProductById = (id)     => api.get(`/products/${id}`);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const apiRegister     = (data) => api.post('/auth/register', data);
export const apiLogin        = (data) => api.post('/auth/login', data);
export const apiLogout       = ()     => api.post('/auth/logout');
export const apiGetMe        = ()     => api.get('/auth/me');
export const apiGetProviders = ()     => api.get('/auth/providers');

export const startGoogleOAuth = () => {
  window.location.href = `${API_BASE}/auth/google`;
};

// ── RFQ (Blue Cart) ───────────────────────────────────────────────────────────
// data must be a FormData instance (built in SubmitRFQPage.js).
// Passing FormData to axios automatically sets Content-Type: multipart/form-data
// with the correct boundary — do NOT set it manually or the boundary is lost.
export const submitRFQ = (data) =>
  api.post('/rfq-cart/submit', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getRFQOrders    = ()     => api.get('/rfq-cart/orders');
export const getRFQOrderById = (id)   => api.get(`/rfq-cart/orders/${id}`);

// ── Checkout (Green Cart) ─────────────────────────────────────────────────────
export const initiateCheckout = (data)      => api.post('/checkout-cart/initiate', data);
export const confirmCheckout  = (sessionId) => api.post('/checkout-cart/confirm', { sessionId });

export default api;
